import React from "react";
import Video from "./Video/video";

function App() {
  return (
    <div>
      <Video />
    </div>
  );
}

export default App;
